import(/* webpackMode: "eager" */ "/app/apps/ashtrom-international/app/[locale]/not-found.tsx");
